import ManagedLookup from '../components/ManagedLookup';
import useLookupPage from '../hooks/useLookupPage';
import fields from './fields';
import columns from './columns';

const LicenseTypes = ({ definition }) => {
    const page = useLookupPage('license-types', columns);
    return <ManagedLookup definition={definition} columns={columns} fields={fields} page={page} />;
};

export default LicenseTypes;
